// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAwokb } from "../../../icons/mono/build/icon-awokb.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AwokbIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAwokb.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AwokbIcon.displayName = 'AwokbIcon';
}

export default AwokbIcon;